<template>
  <v-menu max-width="290">
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="formatedDate"
        slot="activator"
        class="select"
        :label="label"
        height="24"
        dense
        solo
        append-icon="mdi-calendar-range"
        v-on="on"
        readonly
      >
        <template slot="label">
          <span class="itemText">{{ label }}</span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker @change="updateValue($event)" locale="pt-br" :value="value"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }
  },
  computed: {
    formatedDate() {
      return this.formatDate(this.value);
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.select {
  width: 240px;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
  margin-bottom: -30px;
}

.itemText {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}
</style>